// extracted by mini-css-extract-plugin
export default {"alert":"AlertMobile_alert__PVrmG","root":"AlertMobile_root__eHVLm"};